module.exports = __webpack_public_path__ + "img/ma-back.a86ccf93.png";